fragment SmsDripSequenceFragment on SmsCampaign {
    id
    name
    htmlUrlPath
    deletedTime
    editions {
        totalCount
    }
    owner {
        id
        name
    }
    from {
        id
        status
        phone {
            numberFormatted
        }
    }
    type
    createdTime
    modifiedTime
    status
    creatorUser {
        id
        name
    }
    isBusinessHoursOnly
    isStopOnGoal
    isStopOnLeadClose
    isStopOnRemovedFromAudience
    lastStatusChangeTime
    startTrigger {
        id
        type
        humanReadableTitle
        humanReadableSubtitle
        conditions {
            type
            config {
                ... on ConditionConfigEntityFilter {
                    filter {
                        ... on EntityFilterFieldConfigRelationship {
                            relationshipAnyAll
                            relationshipData
                        }
                        ... on EntityFilterFieldConfigEnum {
                            enumValue
                            enumIsNot
                        }
                    }
                }
                ... on ConditionConfigTag {
                    tags
                }
                ... on ConditionConfigAudience {
                    audiences
                }
            }
        }
    }
    goal {
        id
        type
        conditions {
            type
            config {
                ... on ConditionConfigEntityFilter {
                    filter {
                        ... on EntityFilterFieldConfigRelationship {
                            relationshipAnyAll
                            relationshipData
                        }
                        ... on EntityFilterFieldConfigEnum {
                            enumValue
                            enumIsNot
                        }
                    }
                }
                ... on ConditionConfigLink {
                    links
                }
                ... on ConditionConfigTag {
                    tags
                }
                ... on ConditionConfigAudience {
                    audiences
                }
            }
        }
        humanReadableTitle
        humanReadableSubtitle
        action {
            type
            humanReadableTitle
            humanReadableSubtitle
            config {
                isValid
                ... on ActionConfigAddTags {
                    tags {
                        id
                        name
                    }
                }
                ... on ActionConfigAddAudiences {
                    audiences {
                        id
                        name
                    }
                }
                ... on ActionConfigRemoveAudiences {
                    audiences {
                        id
                        name
                    }
                }
            }
        }
    }
    engagementStats {
        totalSentCount
        responseRate
        responseCount
        undeliveredRate
        undeliveredCount
        optoutCount
        optoutRate
        dripProgressionsReceivedEveryMessageRate
        dripProgressionsGoalMetRate
        dripProgressionTotalRecipients
    }
    numInProgressDripProgressions
    isRemovable
}
